export default ({ url }) => {
  open(
    url.startsWith(`http`)
      ? url
      : `//${url}`,
    `_blank`
  )
}
